
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import FindDoctors from './Components/Pages/FindDoctors';
import FindDiagonictics from './Components/Pages/FindDiagonictics';
import Request from './Components/Pages/Request';

import Patient from './Components/Pages/Patient';
import ViewDoctors from './Components/Pages/ViewDoctors';
import ViewDiagonstics from './Components/Pages/ViewDiagonstics';
import Login from './Components/Pages/Login';
import Dashboard from './Components/Pages/Dashboard';
import { Toaster } from 'sonner';
import { Provider } from 'react-redux';
import { store } from './redux/store';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
      <BrowserRouter>
       <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          style: {
            background: "#000",     
            color: "#fff",       
            borderRadius: "10px",   
            padding: "14px 18px",
            fontSize: "14px",
          },
        }}
      />
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/dashboard' element={<Dashboard/>}/>
        <Route path='/find-doctors' element={<FindDoctors/>}/>
        <Route path='/find-diagonistics' element={<FindDiagonictics/>}/>
        <Route path='/request' element={<Request/>}/>
        <Route path='/patients' element={<Patient/>}/>
         <Route path='/view-doctors' element={<ViewDoctors/>}/>
          <Route path='/view-diagonistics' element={<ViewDiagonstics/>}/>
      </Routes>
      </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
